<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>商家分类</el-breadcrumb-item>
        </el-breadcrumb>

        <!-- 添加 -->
        <el-form :inline="true" style="margin-top: 20px;">
            <el-form-item>
                <el-button size="small" type="primary" icon="el-icon-plus" @click="openClass()">添加</el-button>
            </el-form-item>
        </el-form>

        <!--列表-->
        <el-table size="small" :data="classData" highlight-current-row v-loading="loading" border
            element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column align="center" show-overflow-tooltip sortable prop="id" label="id" width="70"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip sortable prop="name" label="分类名称" width="200"></el-table-column>
            <el-table-column align="center" show-overflow-tooltip sortable prop="type" label="分类类型" :formatter="Type"
                width="200">
                <template slot-scope="scope">
                    附件商家
                </template>
            </el-table-column>
            <el-table-column align="center" show-overflow-tooltip sortable prop="createTime" label="创建时间" >
                <template slot-scope="scope">
                    <div>{{ transformDate(scope.row.createTime) }}</div>
                </template>
            </el-table-column>
            <el-table-column align="center"  fixed="right" label="操作" width="200">
                <template slot-scope="scope">
                    <el-button size="mini" type="primary" @click="openClass(scope.row)"
                        :disabled="(scope.row.type == 1 || scope.row.type == 0) && (scope.row.name == '推荐' || scope.row.name == '关注') ? true : false">修改</el-button>
                    <el-button size="mini" type="danger" @click="deleClass(scope.row)"
                        :disabled="(scope.row.type == 1 || scope.row.type == 0) && (scope.row.name == '推荐' || scope.row.name == '关注') ? true : false">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <!-- 编辑界面 -->
        <el-dialog :title="title" :visible.sync="editFormVisiible" width="30%">
            <el-form label-width="120px">
                <el-form-item label="分类名称" prop="name">
                    <el-input size="small" v-model="name" auto-complete="off" placeholder="请输入分类名称"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click='closeDialog()'>取消</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="addClass()"
                    v-if="title == '添加'">添加</el-button>
                <el-button size="small" type="primary" :loading="loading" @click="upClass()"
                    v-if="title == '修改'">修改</el-button>
            </div>
        </el-dialog>

        <!-- 分页组件 -->
        <!-- <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination> -->


    </div>
</template>

<script>
import Pagination from '../../components/Pagination'
import { merchantTypeApi,merchantListApi ,modifyMerchantTypeApi,delMerchantTypeApi} from '../../api/userMG'

export default {
    data() {
        return {
            // 发布分类数据
            classData: [],

            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 20,
                total: 10
            },
            name: '',
            loading: false,
            editFormVisiible: false,
            title: "添加",
          
        }
    },
    // 注册组件
    components: {
        Pagination
    },
    created() {
        this.getClass(1)
    },
    methods: {
        // 分页插件事件
        callFather(parm) {
            console.log('parm==========', parm)
            this.pageparm.page = parm.currentPage
            this.getClass(parm.currentPage)
        },

        // type值转换
        Type: function (row) {
            if (row.type == 0) {
                return "文章"
            } else if (row.type == 1) {
                return "视频"
            }
        },

        //显示编辑界面
        openClass: function (row) {
            console.log("row", row);
            this.editFormVisiible = true;
            if (row != undefined && row != "undefined") {
                this.title = "修改";
                this.id = row.id;
                this.value = row.type
                this.type = row.type;
                this.name = row.name;
            } else {
                this.title = "添加";
                this.type = "";
                this.name = "";
            }
        },

        // 添加
        addClass() {
            this.loading = true
            merchantTypeApi({
                name: this.name
            }).then((res) => {
                if (res.code == 200) {
                    this.loading = false
                    this.$message.success(res.msg)
                    this.editFormVisiible = false
                    this.name = ''
                    this.getClass(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg)
                }
            })
        },
        // 关闭编辑对话框
        closeDialog() {
            this.editFormVisiible = false
            this.$message({
                type: 'info',
                message: '已取消编辑'
            })
        },

        // 删除
        deleClass(row) {
            this.$confirm('确定删除吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'success'
            }).then(() => {
                let data = {
                    id: row.id,
                }
                console.log(data,'上传')
                delMerchantTypeApi(data).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.msg)
                        this.getClass(1)
                    } else {
                        this.$message.error(res.msg);
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },

        // 修改
        upClass() {
            this.loading = true;
            modifyMerchantTypeApi({
                id: this.id,
                name: this.name,
            }).then((res) => {
                this.loading = false;
                if (res.code == 200) {
                    this.editFormVisiible = false
                    this.$message.success(res.msg)
                    this.getClass(1)
                } else {
                    this.editFormVisiible = false
                    this.$message.error(res.msg);
                }
            })
        },

        getClass(page) {
            this.loading = true;
            // 获取发布分类列表
            var parameter = {
                page: (page - 1) * 20,
                name: this.name
            }
            console.log("parameter", parameter)

            merchantListApi().then(res =>{
                this.loading = false;
                if (res.code != 200) {
                    this.$Message({
                        type: "info",
                        message: res.msg
                    });
                } else {
                    this.classData = res.data.list;
                    this.pageparm.currentPage = page;
                    this.pageparm.total = res.data.count;
                    return;
                }
            })
        
        },
    }

}
</script>

<style></style>


// WEBPACK FOOTER //
// src/views/classification/merchant_type.vue